import { motion, AnimatePresence } from 'framer-motion';
import { Check, Loader2, AlertCircle, RefreshCw } from 'lucide-react';
import { useAuth, SAVE_STATUS } from '@/contexts/AuthContext';

const SaveStatusIndicator = () => {
  const { saveStatus, saveError, isAuthenticated } = useAuth();
  
  // Don't show anything if not authenticated (saves go to localStorage only)
  if (!isAuthenticated) return null;
  
  // Don't show when idle
  if (saveStatus === SAVE_STATUS.IDLE) return null;
  
  const getStatusConfig = () => {
    switch (saveStatus) {
      case SAVE_STATUS.SAVING:
        return {
          icon: <Loader2 size={14} className="animate-spin" />,
          text: 'Saving...',
          bgColor: 'bg-stone-100',
          textColor: 'text-stone-500',
        };
      case SAVE_STATUS.SAVED:
        return {
          icon: <Check size={14} />,
          text: 'Saved',
          bgColor: 'bg-green-50',
          textColor: 'text-green-600',
        };
      case SAVE_STATUS.RETRYING:
        return {
          icon: <RefreshCw size={14} className="animate-spin" />,
          text: "Couldn't save. Retrying...",
          bgColor: 'bg-amber-50',
          textColor: 'text-amber-600',
        };
      case SAVE_STATUS.ERROR:
        return {
          icon: <AlertCircle size={14} />,
          text: saveError || "Still having trouble saving. Your changes are kept locally—please try again soon.",
          bgColor: 'bg-red-50',
          textColor: 'text-red-600',
        };
      default:
        return null;
    }
  };
  
  const config = getStatusConfig();
  if (!config) return null;
  
  return (
    <AnimatePresence>
      <motion.div
        initial={{ opacity: 0, y: -10 }}
        animate={{ opacity: 1, y: 0 }}
        exit={{ opacity: 0, y: -10 }}
        transition={{ duration: 0.2 }}
        className={`fixed top-20 left-1/2 -translate-x-1/2 z-50 ${config.bgColor} ${config.textColor} px-4 py-2 rounded-full shadow-sm flex items-center gap-2 text-sm`}
        data-testid="save-status-indicator"
      >
        {config.icon}
        <span>{config.text}</span>
      </motion.div>
    </AnimatePresence>
  );
};

export default SaveStatusIndicator;
